(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.cardSlider = {
        attach: function (context) {
            const slider = once('card-slider', '.cards-slider__items .swiper', context)[0];
            if (!slider) return;

            if (typeof Swiper === 'undefined') {
                console.warn('Swiper library not loaded');
                return;
            }

            const DESKTOP_BREAKPOINT = 992;
            const paginationEl = slider.querySelector('.swiper-pagination');
            const slideCount = slider.querySelectorAll('.swiper-slide').length;

            const togglePagination = (width) => {
                if (!paginationEl) {
                    return;
                }

                paginationEl.style.display = width >= DESKTOP_BREAKPOINT && slideCount <= 3 ? 'none' : '';
            };

            let swiperInstance = null;

            const buildOptions = () => ({
                enabled: true,
                slidesPerView: 'auto',
                spaceBetween: 16,
                loop: true,
                centeredSlides: true,
                pagination: {
                    el: paginationEl || undefined,
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        centeredSlides: false,
                    },
                    992: {
                        enable: false,
                        loop: false,
                    },
                }
            });

            const initSlider = () => {
                if (swiperInstance) {
                    return;
                }

                try {
                    swiperInstance = new Swiper(slider, buildOptions());
                    slider.classList.add('is-swiper-active');
                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                    swiperInstance = null;
                }
            };

            const destroySlider = () => {
                if (!swiperInstance) {
                    return;
                }

                swiperInstance.destroy(true, true);
                swiperInstance = null;
                slider.classList.remove('is-swiper-active');
            };

            const syncSliderState = () => {
                const width = window.innerWidth;

                if (width >= DESKTOP_BREAKPOINT) {
                    togglePagination(width);
                    destroySlider();
                    slider.classList.add('swiper-disabled');
                } else {
                    if (!swiperInstance) {
                        initSlider();
                    } else {
                        swiperInstance.update();
                    }

                    slider.classList.remove('swiper-disabled');
                    togglePagination(width);
                }
            };

            const debouncedSync = Drupal.debounce ? Drupal.debounce(syncSliderState, 150) : syncSliderState;

            syncSliderState();
            window.addEventListener('resize', debouncedSync, { passive: true });
        }
    };

})(Drupal, once);